// 后台多选驳回原因使用“1、原因；2、原因”格式，单条原因自身也可能包含分号或换行。
export function splitClaimRejectionReasons(remark) {
  if (typeof remark !== 'string' || !remark.trim()) {
    return [];
  }

  const text = remark.trim();
  function findMarkers(marker) {
    const matches = [];
    let match;
    while ((match = marker.exec(text)) !== null) {
      matches.push({ index: match.index, end: marker.lastIndex, number: Number(match[2]) });
    }
    return matches;
  }

  // 优先使用后台的分号边界，原因正文里的换行编号只是说明步骤。
  let matches = findMarkers(/(^|[；;]\s*)(\d+)(?:[、．]|\.(?!\d))\s*/g);
  if (matches.length < 2) {
    matches = findMarkers(/(^|\s+)(\d+)(?:[、．]|\.(?!\d))\s*/g);
  }

  // 自由文本没有明确的连续编号时，完整展示，避免按普通标点误拆原因。
  if (matches.length < 2 || matches[0].index !== 0 ||
      matches.some((item, index) => item.number !== index + 1)) {
    return [text];
  }

  const reasons = matches.map((item, index) =>
    text.slice(item.end, index + 1 < matches.length ? matches[index + 1].index : text.length).trim()
  );
  return reasons.every(Boolean) ? reasons : [text];
}
